import React from "react";
import Snackbar from "../../components/UI/Snackbar";

type FormSnackbarProps = Readonly<{
  isOpen: boolean;
  onClose: () => void;
  type: "success" | "error" | "warning" | "info";
  error: string | null;
  apiMessage?: string | null;
  successMessage?: string;
}>;

export function FormSnackbar({
  isOpen,
  onClose,
  type,
  error,
  apiMessage,
  successMessage = "Success! 🎉",
}: FormSnackbarProps) {
  return (
    <Snackbar
      isOpen={isOpen}
      onClose={onClose}
      type={type}
      title={type === "error" ? "Error" : "Success"}
      message={error || apiMessage || successMessage}
      apiMessage={apiMessage ?? undefined}
      autoClose={type === "success"}
      autoCloseDelay={5000}
    />
  );
}
